import { createAsyncThunk } from "@reduxjs/toolkit";

import { deleteRequest } from "../../axios/axios";
import { fetchGoogleCalendarUser } from "../../services/meetings.service";

const getToken = () => {
  return localStorage.getItem("token");
};

export const connectGoogle = createAsyncThunk(
  "meetings/connectGoogle",
  async (username) => {
    try {
      const data = fetchGoogleCalendarUser(username);
      return data;
    } catch (err) {
      return err.response ? err.response.data.message : err.message;
    }
  },
);

export const disconnectGoogle = createAsyncThunk(
  "meetings/disconnectGoogle",
  async () => {
    try {
      const { data } = await deleteRequest(
        "/api/v1/meetings/google-meet",
        getToken(),
      );

      if (data.status === "success") {
        return data.data;
      }
    } catch (err) {
      return err.response ? err.response.data.message : err.message;
    }
  },
);
